// Central asset registry: official Kiltro logo + textures + curated beer photos
export const KILTRO_ASSETS = {
  logo: "/kiltro-logo-clean.png?v=2026-2",
  heroBar: "https://customer-assets.emergentagent.com/job_brews-map-santiago/artifacts/m1xmav7l_image.png",
  // Brushstroke = pinceladas negras con amarillo (sumloizh_image.png)
  brushstroke: "https://customer-assets.emergentagent.com/job_brews-map-santiago/artifacts/sumloizh_image.png",
  // Yellow grunge = amarillo rayado (v3akyu4v)
  yellowGrunge: "https://customer-assets.emergentagent.com/job_brews-map-santiago/artifacts/v3akyu4v_3c40332f6b6e8b189da229ea71d886d9.jpg",
  woodPaint: "https://customer-assets.emergentagent.com/job_brews-map-santiago/artifacts/j1tjrl38_931820bb40294553e95e760d46e71a16.jpg",
  stamp2026: "https://customer-assets.emergentagent.com/job_brews-map-santiago/artifacts/ots45agw_image.png",
  dogSilhouette: "https://customer-assets.emergentagent.com/job_brews-map-santiago/artifacts/9s6m2r6k_image.png",
};

export const KILTRO_BRAND = {
  name: "Kiltro",
  domain: "kiltroscout.cl",
  contactEmail: "contacto@kiltroscout.cl",
  whatsapp: "+56978096537", // Número comercial Kiltro
  city: "Santiago de Chile",
  founded: "2026",
};
